import { Trans } from '@lingui/react/macro';
import { useMemo } from 'react';

import type { AdActivityDataType } from '@/api/ad';
import { Button } from '@/components/buttons';
import { Badge } from '@/components/typography';
import { AD_SCORE_MAX_LIMIT, AD_SCORE_MIN_LIMIT } from '@/constants';

type Props = {
  selectedAds: AdActivityDataType[];
  onRemoveSelectedAd: (ad: AdActivityDataType) => void;
  onScoreAds: (adIds: string[]) => void;
};

const KeywordTableActionContent = ({ selectedAds, onRemoveSelectedAd, onScoreAds }: Props) => {
  const selectedAdIds = useMemo(() => selectedAds.map((ad) => ad.ad.id), [selectedAds]);

  const disableScore =
    selectedAds.length < AD_SCORE_MIN_LIMIT || selectedAds.length > AD_SCORE_MAX_LIMIT;

  return (
    <div className="flex items-start gap-4">
      <Button disabled={disableScore} onClick={() => onScoreAds(selectedAdIds)}>
        <Trans>Score {disableScore ? '' : ` (${selectedAds.length})`}</Trans>
      </Button>
      <div className="flex flex-wrap gap-1">
        {selectedAds.map((ad) => (
          <Badge key={ad.ad.id} closable onClose={() => onRemoveSelectedAd(ad)}>
            {ad.ad.name}
          </Badge>
        ))}
      </div>
    </div>
  );
};

export default KeywordTableActionContent;
